export default {
  contactListContainer: {
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    width: '230px',
    '&::-webkit-scrollbar': {
      overflow: 'hidden',
    }
  },
  contactList: {
    background: '#fff',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '3px',
      background: 'rgba(0,0,0, 0.2)',
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(0,0,0, 0.4)',
      borderRadius: '10px',
    },
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '20px 0',
  },
  searchAndSubsContainer: {
    flexShrink: '0',
  },
  contactSearchContainer: {
    padding: '0 10px',
    position: 'relative',
  },
  contactSearchInput: {
    border: 'none',
    color: '#4E4C4C',
    background: '#EEECF8',
    minHeight: '20px',
    width: '100%',
    padding: '0 5px',
    margin: '10px 0',
  },
  contactSearchInputClear: {
    position: 'absolute',
    right: '15px',
    fontSize: '14px',
    top: '17px',
    color: 'red',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  contactLink: {
    position: 'relative',
    display: 'flex',
    color: '#000',
    borderBottom: '1px solid #EEECF8',
  },
  contact: {
    padding: '10px 0px 10px 10px',
    fontSize: '11px',
    userSelect: 'none',
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'flex-start',
    '&:hover': {
      background: '#e8e8f7',
      cursor: 'pointer',
    },
  },
  contactRecipient: {
    maxWidth: '155px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  contactNoAuthRecipient: {
    color: 'red',
  },
  contactRecipientTime: {
    color: 'grey',
  },
  contactRecipientContainer: {
    width: '206px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '5px',
  },
  contactMsg: {
    height: '15px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '100%',
    textOverflow: 'ellipsis',
    color: 'grey',
  },
  contactMsgContainer: {
    display: 'flex',
    width: '206px',
  },
  contactLastMsgIcon: {
    marginRight: '5px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    color: 'gray',
  },
  contactMsgUnseenCount: {
    borderRadius: '100%',
    color: '#fff',
    width: '19px',
    height: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contactNotSeen: {
    background: '#EEECF8',
    borderLeft: '5px solid red',
  },
  contactSelected: {
    background: '#419FD9',
    color: '#fff',
    '&:hover': {
      background: '#419FD9',
      cursor: 'pointer',
      color: '#fff',
    },
    '&:focus': {
      background: '#419FD9',
      color: '#fff',
    },
  },
  contactTextSelected: {
    color: '#fff',
  },
  contactYouText: {
    marginRight: '5px',
  },
};
